import { render, staticRenderFns } from "./PublicArticleSearch.vue?vue&type=template&id=908bb15a&"
import script from "./PublicArticleSearch.vue?vue&type=script&lang=js&"
export * from "./PublicArticleSearch.vue?vue&type=script&lang=js&"
import style0 from "./PublicArticleSearch.vue?vue&type=style&index=0&id=908bb15a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports